var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M7 15.7891L12.8945 9.89453L7 4","stroke":"currentColor","stroke-width":"1.65916"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }